const MAX_RECENT_STUDENTS = 50;

const createState = () => ({
  recentStudents: [],
});

const mutations = {
  ADD_STUDENT(state, studentData) {
    if (state.recentStudents.length >= MAX_RECENT_STUDENTS) {
      state.recentStudents.shift();
    }
    state.recentStudents.push(studentData);
  },

  UPDATE_STUDENT(state, updatedData) {
    const studentIndex = state.recentStudents.findIndex((student) => student.oktaId === updatedData.oktaId);

    if (studentIndex !== -1) {
      state.recentStudents.splice(studentIndex, 1, updatedData);
    }
  },

  CLEAR_RECENT_STUDENTS(state) {
    state.recentStudents = [];
  },
};

const actions = {
  addStudent({ commit, state }, studentData) {
    const exists = state.recentStudents.some((student) => student.oktaId === studentData.oktaId);
    if (!exists) {
      commit("ADD_STUDENT", studentData);
    }
  },

  updateStudent({ commit }, updatedData) {
    commit("UPDATE_STUDENT", updatedData);
  },

  clearRecentStudents({ commit }) {
    commit("CLEAR_RECENT_STUDENTS");
  },
};

const getters = {
  getStudentById: (state) => (oktaId) => {
    return state.recentStudents.find((student) => student.oktaId === oktaId);
  },
};

export default {
  namespaced: true,
  state: createState,
  mutations,
  actions,
  getters,
};
